;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "axsgeqiktlj"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="axsgeqiktlj"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDE5/NTc0ODY0ODc5/First_release/pages/Nabi-Home/o-collection/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "c9uemmep9s6"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="c9uemmep9s6"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDE5/NTc0ODY0ODc5/First_release/pages/Nabi-Home/o-collection/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "2rp3lb903w7"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let left = $(this).find('.lh-left .lh-item');
  let right = $(this).find('.lh-right .lh-item');

  let removeAllActive = function(dom, contents) {
    dom.each( function(i) {
      let hasClass = this.classList.contains('active');
      if(hasClass) {
        this.classList.remove('active');
        contents[i].style.maxHeight = `0`;
      }
    });
  }

  let eventAc = function(dom) {
    dom.each( function(i) {
      this.addEventListener('click', () => {
        console.log('click');
        let contents = dom.find('.lh-content');
        let currentHasAc = this.classList.contains('active');
        if(!currentHasAc) {
          removeAllActive(dom, contents);
          this.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        }
      })
    })
  }
  eventAc(left);
  eventAc(right);

 };						cb.bind($('section[data-section-id="2rp3lb903w7"] include[data-name="style_1"][data-id="1"]').get(0))(jQuery);;var cb  = function($) {

$(this).find('.lh-accordion-item .lh-header').on('click', function() {
    var _this = jQuery(this).closest('.lh-accordion-item');
    _this.addClass('active');
    _this.siblings('.active').removeClass('active');
});

 };						cb.bind($('section[data-section-id="2rp3lb903w7"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="2rp3lb903w7"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/sY0Wi3fvkunCjral/faqs/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "LkXw3DBMvA"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

var $this = jQuery(this),
    el_user = $this.find('.lh-btn-user'),
    limit   = 5,
    token = section.settings.instagram,
    index = 0,
    html = '',
    slide = $this.find('.lh-insta-carousel');
    if(token)
    {
      let cache = window.localStorage.getItem(token);
      if(cache)
      {
        let data = JSON.parse(cache);
        if(data.exp > new Date().getTime())
        {
          renderDom(data.data);
        }
        else
        {
          getData(token)
        }
      }else
      {
        getData(token);
      }
    }
    function getData(token)
    {
      jQuery.get('https://graph.instagram.com/me/media',{fields: 'id,caption,media_url,thumbnail_url,media_type,permalink,username,comments_count,like_count', access_token: token,limit  })
      .then((response)=>{
        if(response && response.data)
        {
          if(!window.LAYOUTHUB_LIVE)
          {
            window.localStorage.setItem(token,JSON.stringify({exp:  new Date().setDate(new Date().getDate() +7) , data: response.data}));
          }
          renderDom(response.data)
        }
      })
    }
    function renderDom(data)
    {
      var html = data.map((item)=>{
          el_user.attr("href" , "https://www.instagram.com/" + item.username);
          el_user.attr("title" , item.username);
          el_user.text('#'+item.username);
          let dom  =  '<div class="lh-item' + ((item.media_type == "VIDEO") ? ' lh-video' : '') + '">';
            dom +=  (window.LAYOUTHUB_LIVE || window.location.protocol == "blob:") ? `<a class="lh-effect-ani1" href="${item.permalink}" style="background: url('${(item.media_type == "VIDEO") ? item.thumbnail_url : item.media_url}') center center / cover no-repeat scroll rgb(255, 255, 255);"></a></div>` : 
                                            `<a class="lh-effect-ani1" href="${item.permalink}" data-lh-bg="${(item.media_type == "VIDEO") ? item.thumbnail_url : item.media_url}" style="background: url('data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=') center center / cover no-repeat scroll rgb(255, 255, 255);"></a></div>`;
          return dom;
        });

        html.forEach(function(item, i) {
          var _this = $this.find(`.lh-wrap-${i + 1}`);
          _this.html(html[i])
        });
    }
 };						cb.bind($('section[data-section-id="LkXw3DBMvA"] include[data-name="instagram"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="LkXw3DBMvA"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RGVjLS0yMDIw/NjA3NjY5NzM1/release-12-2020/pages/Y6XRdkOcIbDSnHul/instagram/",						settings: {"instagram":"IGQVJYQUJPSXBCdkt0NWdlanVDTGtkTVpncEowMWk4bDNXTWdQWEw0UXFvMS11TmgzQkd5c08zbUdpblF6OEY5U29lVWdsM0pLdmxFSUNrUzBqLTJrQTFscENPNFNtMWx5aloyTW5R"}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');window.addEventListener("load",()=>{let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","z-index: 10000000000000000","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Page layout provided by &hearts; <a href=\"https://www.layouthub.com/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\">Layouthub.com</a>",a.appendChild(b)});